import { Box, Card, IconButton, Tabs, Tab, darken } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

export default function DetailCard({ handleExit, data, components = [] }) {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm')); // Mobile check

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    function escapeHandler(event) {
      if (event.key === 'Escape') {
        handleExit();
      }
    }
    window.addEventListener('keydown', escapeHandler);
    return () => {
      window.removeEventListener('keydown', escapeHandler);
    };
  }, [handleExit]);

  return (
    <Card
      sx={{
        padding: sm ? '0px' : '20px',
        flex: 1,
        width: sm ? '100%' : 'auto',
        transition: 'width 0.3s',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 1,
        }}
      >
        {components.length > 1 ? (
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            textColor="primary"
            indicatorColor="primary"
            sx={{
              ml: 1,
            }}
          >
            {components.map((component, index) => (
              <Tab
                key={component.title}
                label={component.title}
                sx={{
                  ...(activeTab === index && {
                    color: '#fff',
                    borderRadius: 1,
                  }),
                }}
              />
            ))}
          </Tabs>
        ) : (
          <Box />
        )}
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            position: 'relative',
            zIndex: 99,
          }}
        >
          {components[activeTab].url && (
            <IconButton
              onClick={() => {
                navigate(`${components[activeTab].url}/${data._id}`);
              }}
            >
              <FullscreenIcon />
            </IconButton>
          )}
          <IconButton
            onClick={handleExit}
            sx={{
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: theme.palette.hover.main,
              },
              '&:active': {
                backgroundColor: darken(theme.palette.hover.main, 0.1),
              },
              '& .MuiSvgIcon-root': {
                position: 'relative',
                zIndex: 1,
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          padding: 1,
          width: '100%',
          flex: 1,
          height: sm ? 'auto' : '100%',
          overflowY: sm ? 'auto' : 'hidden',
        }}
      >
        {components.length > 1
          ? components.map((component, index) => {
              if (index === activeTab) {
                return (
                  <component.Component
                    data={data}
                    key={component.title}
                    additionalProps={component.additionalProps}
                  />
                );
              }
              return null;
            })
          : components.map((component) => (
              <component.Component
                data={data}
                key={component.title}
                additionalProps={component.additionalProps}
              />
            ))}
      </Box>
    </Card>
  );
}
